const BEIJING_OFFSET_MS = 8 * 60 * 60 * 1000;

/** Display only: never replace the saved instant with this calendar date. */
export function quoteExpiryDate(instant: string | null): string {
  if (instant === null) return '';
  return new Date(Date.parse(instant) + BEIJING_OFFSET_MS)
    .toISOString()
    .slice(0, 10);
}

/** Only a deliberate date-picker edit gets Beijing end-of-day semantics. */
export function quoteExpiryFromDate(date: string): string | null {
  if (!date) return null;
  const instant = Date.parse(`${date}T23:59:59.999+08:00`);
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
    !Number.isFinite(instant) ||
    quoteExpiryDate(new Date(instant).toISOString()) !== date
  )
    throw new Error('报价有效期不是有效日期');
  return new Date(instant).toISOString();
}

// Link expiry remains form-only; no policy/configuration versions are inferred.
export function validateCustomerShareDates(
  quoteDate: string,
  linkDate: string,
  now = Date.now(),
  quoteInstant?: string | null,
): { quoteError?: string; linkError?: string; effectiveDateTime?: string } {
  const validate = (value: string, label: string) => {
    if (!value) return `请填写${label}`;
    const timestamp = Date.parse(`${value}T23:59:59.999+08:00`);
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
      !Number.isFinite(timestamp) ||
      new Date(timestamp + 8 * 60 * 60 * 1000).toISOString().slice(0, 10) !==
        value
    )
      return `${label}不是有效日期`;
    if (timestamp <= now) return `${label}已过期，请选择未来有效日期`;
    return undefined;
  };
  const quoteError =
    quoteInstant === undefined
      ? validate(quoteDate, '报价有效期')
      : quoteInstant === null
        ? '请填写报价有效期'
        : !Number.isFinite(Date.parse(quoteInstant))
          ? '报价有效期不是有效日期'
          : Date.parse(quoteInstant) <= now
            ? '报价有效期已过期，请选择未来有效日期'
            : undefined;
  const linkError = validate(linkDate, '链接有效期');
  // Preview only: keep the original quote instant, compare before formatting.
  const effectiveTimestamp =
    quoteError || linkError
      ? undefined
      : Math.min(
          Date.parse(quoteInstant ?? `${quoteDate}T23:59:59.999+08:00`),
          Date.parse(`${linkDate}T23:59:59.999+08:00`),
        );
  return {
    quoteError,
    linkError,
    effectiveDateTime:
      effectiveTimestamp === undefined
        ? undefined
        : new Date(effectiveTimestamp + BEIJING_OFFSET_MS)
            .toISOString()
            .slice(0, 19)
            .replace('T', ' '),
  };
}
